import { createSelector } from 'reselect'

export const getJobProducts = (state) => state.Manager.Products.products
export const getJobProductArray = createSelector(
	getJobProducts,
	(products) => {
		const productArray = []
		for (const key in products) {
			productArray.push({ ...products[key], uid: key })
		}
		return productArray
	}
)
